/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Muqsit",
  logo_name: "Muqsit.h()",
  full_name: "Muqsit Hussain",
  subTitle:
    "Full Stack Developer, Life Long Learner and A Computer Science Student.",
  resumeLink:
    "https://drive.google.com/drive/folders/1yau49LIGE2n1f4AaGmI4mlyuOySnNJXW?usp=share_link",
  mail: "mailto:muqsithussain01@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/Muqsit-hussain6",
  linkedin: "https://www.linkedin.com/in/muqsit-hussain6/",
  gmail: "muqsithussain01@gmail.com",
  facebook: "https://www.facebook.com/muqsit.hussain.9",
  twitter: "https://twitter.com/muqsithussain01",
  instagram: "https://www.instagram.com/muqsit_hussain6/",
};

const skills = {
  data: [
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive User Interfaces and Backend for web applications",
        "⚡ Building responsive website front end using ReactJS and NextJS",
        "⚡ Database Management using PostgreSql and MySQL",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#563d7c",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Next.JS",
          fontAwesomeClassname: "simple-icons:next-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "PostgreSql",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },


  ],
};

const degrees = {
  degrees: [
    {
      title: "Sukkur Institute of Business Administration",
      subtitle: "Bachelors in Computer Science and Engineering",
      logo_path: "IBA_logo.jpg",
      alt_name: "SIBA",
      duration: "2021 - 2025",
      descriptions: [
        "⚡  I'm currently pursuing my Bachelors in Computer Science and Engineering.",
        "⚡ I have studied core subjects like Data Structures, DBMS, OOP etc.",
        "⚡ I have implemented several projects based on what I've learned under my Computer Science course. ",
      ],
      website_link: "https://www.iba-suk.edu.pk/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Full Stack Development Diploma",
      subtitle: "Become a Full Stack Dev",
      logo_path: "Full-Stack-Developer-Certification.png",
      alt_name: "IBA",
      color_code: "#2AAFED",
    },
    {
      title: "Git",
      subtitle: "Git for Beginners",
      logo_path: "Git",
      alt_name: "GIT",
      color_code: "#f47e2c",
    },
    {
      title: "Bootstrap",
      subtitle: "Bootstrap for beginners",
      logo_path: "Bootstrap",
      alt_name: "bootstrap",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    {
      title: "React Js",
      subtitle: "React for beginners",
      logo_path: "React",
      alt_name: "Reply",
      color_code: "#2AAFED",
    },
    {
      title: "Data Structures",
      subtitle: "Introduction to algorithms",
      logo_path: "DSA.png",
      alt_name: "DSA",
      color_code: "#2AAFED",
    },
    {
      title: "OOP",
      subtitle: "Object oriented concepts",
      logo_path: "OOP.png",
      alt_name: "OOP",
      color_code: "#88e7ce",
    },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work/Internship",
  description:
    "I have mostly done projects on my own and I am actively looking for internships. I love attending workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Junior QA Intern",
          company: "QA-Testers",
          logo_path: "QA",
          duration: "Sept 2020 - Oct 2020",
          location: "Remote",
          description: ` Junior QA intern , My job was to test software's , websites and Apps for potential bugs and Errors. 
          `,

          color: "#0071C5",
        },
      ],
    },

  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My Projects showcase my experience with programming languages like Java, C++, CSS, HTML, Bootstrap, React, and Next.js, as well as various libraries and frameworks. I've developed responsive front-end interfaces and robust back-end systems, and I'm always learning new technologies to stay up-to-date with industry trends.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "porfilepic.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Email me",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Book Cellar",
      url: "https://react-basics-muqsithussain.netlify.app/",
      description:
        "React-based web application that elegantly showcases books, with a perfect blend of HTML, CSS, and JavaScript.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },

      ],
    },
    {
      id: "1",
      name: "Java Client Dashboard",
      url: "https://github.com/Muqsit-hussain6/JAVA--DASHBOARD-JDBC",
      description:
        "I designed a JDBC-based dashboard that connects to a MS Access database, utilizing OOP and ArrayLists/Queues for efficient client data management",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
      ],
    },
    {
      id: "2",
      name: "PhoneBook Management",
      url: "https://github.com/Muqsit-hussain6/PhoneBookManagement",
      description:
        "Java phonebook system tracks call logs and manages contacts using ArrayList, Queue, and file I/O.",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
      ],
    },
    {
      id: "3",
      name: "Subway Counter",
      url: "https://ridercount.netlify.app/",
      description:
        "My JavaScript project counts subway visitors by increasing a displayed counter each time the button is pressed",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      id: "4",
      name: "BlackJack game",
      url: "https://blackjack-muqsithussain.netlify.app/",
      description:
        "Created a Basic Blackjack game.",
      languages: [
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
      ],
    },
    {
      id: "5",
      name: "Portfolio Website",
      url: "https://github.com/Muqsit-hussain6/PortFolio-Website2",
      description: "Made a Portfolio Website Using Bootstrap",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos-bootstrap",
        },
      ],
    }
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
